<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-01 17:41:45
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-11 14:54:53
-->
<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-01 17:41:45
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-10 12:38:32
-->
<template>
	<div
		class="activity-square main-content-padding"
		v-scroll-lazy-load="{
			loadData,
			distance: 100,
			delay: 1000,
			callback: fn => this.$once('hook:beforeDestroy', () => fn()),
		}"
	>
		<Panel :contentPaddingTop="12" class="index" :class="{ comingSoon: $isPlatOr(platformId, ['Sp']) }">
			<platformTab @change="handleClickTab" :showAll="false" :platformId="platformId" />
			<template v-if="$isPlatOr(['Dy', 'Ks'])">
				<div v-show="showPlatformContent">
					<SubTabs class="mt-8 mb-10" @tab-click="handleClick" v-model="tabName" :list="tableArr">
						<template slot-scope="{ item }">
							<span>{{ item.label }}</span>
						</template>
					</SubTabs>
					<ksSearch ref="ksSearch" @onSubmit="ksOnSubmit" :tabName="tabName" v-if="$isKs()"></ksSearch>
					<dySearch v-else ref="dySearch" @onSubmit="dyOnSubmit" />
				</div>
			</template>
			<div class="flex flex-just-center align-center" style="margin-top: 100px" :class="{ emptySPBox: $isPlatOr(platformId, ['Sp']) }" v-else>
				<emptyPage ref="emptyPage">
					<img slot="image" src="@/assets/public/dev-img.png" alt="" />
					<p class="fz-14 yx-color-text-regular" slot="desc">敬请期待</p>
				</emptyPage>
			</div>
		</Panel>

		<template v-if="$isPlatOr(['Dy', 'Ks'])">
			<!-- 快手已报名不展示 -->
			<Panel v-show="showPlatformContent">
				<div class="flex flex-just-between">
					<updateTime v-if="$isDy()" ref="updateTime" :type="sync_type" @updateList="show()"></updateTime>
					<div class="form-item">
						<div class="form-label">团长</div>
						<div class="content">
							<commander-select
								:show-default="true"
								:platformId="platformId"
								v-model="authorityId"
								:show-all="true"
								:show-close="false"
								@change="getList('search')"
							></commander-select>
						</div>
					</div>
				</div>
			</Panel>
			<div class="mt-16 pb-24 radius-8" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255)" v-show="showPlatformContent">
				<div v-if="list.length">
					<template v-if="$isDy()">
						<dyCardList :tabName="tabName" :list="list" @changeData="changeData" :selectedList="selectionShopArr" @checkedItemFn="checkedItemFn" />
					</template>
					<template v-else>
						<ksCardList
							v-if="tabName === '0'"
							:list="list"
							@changeData="changeData"
							:selectedList="selectionShopArr"
							@checkedItemFn="checkedItemFn"
						/>
						<Panel v-else>
							<ks-tab :list="list" />
						</Panel>
					</template>
					<div
						v-show="!noMore"
						class="loading-text"
						v-loading="loading"
						element-loading-text="拼命加载中"
						element-loading-spinner="el-icon-loading"
					></div>
					<div class="no-more fz-12 flex-row flex-center yx-color-text-secondary" v-if="noMore">—— 没有更多了 ——</div>
				</div>
				<empty v-else :isSearch="true" @btnClick="synchroFun" btnText="同步团长活动" :btnShow="$isDy()" ref="empty"></empty>
			</div>
		</template>
		<synchro ref="synchro"></synchro>
		<tips ref="tips"></tips>
		<AuthAlertDialog ref="authAlertDialog"></AuthAlertDialog>
		<el-backtop class="back-top" target=".activity-square" :visibility-height="1200" :bottom="200" :right="40"></el-backtop>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { PLATFORM_DY, PLATFORM_KS } from '@/utils/dataMap';
import dySearch from './compoments/dySearch.vue';
import ksSearch from './compoments/ksSearch.vue';
import synchro from '@/views/common/dialog/synchro.vue';
import updateTime from '../../components/updateTime.vue';
import authMixin from '@/modules/auth/mixin';
import { checkAuthorize } from '@/api/shopManage';
import { activitySearch, activitySync, activityKsList, activityKsApplyList } from '@/api/secondColonelManage';
import empty from '@/views/common/empty/index.vue';
import dyCardList from './compoments/dyCardList.vue';
import ksCardList from './compoments/ksCardList.vue';
import ksTab from './compoments/ksTab.vue';
import { platformMixin } from '@rd/rd-ui';
import { getCommanderList } from '@/components/commanderSelect/index.js';
import commanderSelect from '@/components/commanderSelect/index.vue';
import bottomfixed from '@/components/ui/bottomFixed/bottomFixed.vue';
import dataMap from '../../../../utils/dataMap';
import SubTabs from '@/components/ui/subTabs/index.vue';
import emptyPage from '@/views/common/empty/index.vue';
export default {
	name: 'index',
	components: {
		dySearch,
		ksSearch,
		synchro,
		Tips: () => import('@/modules/auth/tips.vue'),
		AuthAlertDialog: () => import('@/modules/auth/alert.vue'),
		updateTime,
		empty,
		dyCardList,
		ksCardList,
		ksTab,
		commanderSelect,
		bottomfixed,
		SubTabs,
		emptyPage,
	},
	mixins: [authMixin, platformMixin],
	watch: {
		platformId() {
			this.authorityId = '';
		},
	},
	data() {
		return {
			tabName: '0',
			tableArr: [
				{ label: '全部活动', name: '0' },
				{ label: '已报名', name: '1' },
			],
			platformId: 1,
			options: { selectable: false },
			isEmptyObj: {
				isEmpty: false,
				isEmptyShop: true,
				searchEmpty: false,
				isAuth: true,
			},
			list: [],
			filterArr: [],
			selectionShopArr: [],
			allChecked: false,
			dyParams: {
				is_apply: '0',
			},
			ksParams: {
				activityType: '1',
			},
			sync_type: '3',
			loading: false,
			tableLoading: false,
			pageInfo: {
				page_index: 1,
				page_size: 20,
			},
			authorityId: '',
			isSearch: false,
			noMore: false,
		};
	},
	computed: {
		...mapGetters(['defaultPlatform', 'isDarenPartner']),
	},
	created() {
		this.platformId = +this.defaultPlatform;
		const { q = '' } = this.$route.query;
		this.dyParams.institutionName = q;
	},
	mounted() {
		if (this.$isDy()) {
			this.$nextTick(() => {
				this.getSyncTime();
			});
		}
	},
	methods: {
		loadData() {
			if (this.noMore) {
				return;
			}
			++this.pageInfo.page_index;
			this.getList();
		},
		handleClickTab(e) {
			const temPF = {
				[+dataMap.PLATFORM_DY.value]: () => {
					this.dyParams = {
						is_apply: '0',
					};
				},
				[+dataMap.PLATFORM_KS.value]: () => {
					this.ksParams = {
						activityType: '1',
					};
				},
			};
			temPF[+this.platformId] && temPF[+this.platformId]();
			this.pageInfo.page_index = 1;
			this.platformId = e;
			this.tabName = '0';
			if (!this.showPlatformContent) return;
			if (this.$isDy()) {
				this.$nextTick(() => {
					this.getSyncTime();
				});
			}
		},
		handleClick(e) {
			this.dyParams.is_apply = e;
			this.pageInfo.page_index = 1;
			const temPF = {
				[dataMap.PLATFORM_DY.value]: () => {
					this.$nextTick(() => {
						this.getSyncTime();
						this.$refs.dySearch?.onClear();
					});
				},
				[dataMap.PLATFORM_KS.value]: () => {
					this.$nextTick(() => {
						this.$refs.ksSearch?.onClear();
					});
				},
			};
			temPF[this.platformId]();
		},
		async getList(type) {
			try {
				const { platformId, tabName, authorityId: authority_id } = this;
				if (type) this.tableLoading = true;
				this.loading = true;
				const api = {
					[PLATFORM_DY.value]: activitySearch,
					[PLATFORM_KS.value]: tabName === '0' ? activityKsList : activityKsApplyList,
				};
				let params = {
					[PLATFORM_DY.value]: this.dyParams,
					[PLATFORM_KS.value]: this.ksParams,
				};
				const { list = [], page = {} } = await api[platformId]({ ...params[platformId], ...this.pageInfo, authority_id });
				this.list = this.pageInfo.page_index === 1 ? list : [...this.list, ...list];
				this.noMore = !page.page_has;
			} finally {
				if (type) this.tableLoading = false;
				this.loading = false;
			}
		},
		selectionChange(val) {
			this.selectionShopArr = val;
			if (!this.selectionShopArr.length) {
				this.allChecked = false;
			}
			if (this.selectionShopArr.length == this.filterArr.length) {
				this.allChecked = true;
			} else {
				this.allChecked = false;
			}
		},
		batchGroup() {
			if (!this.selectionShopArr.length) return;
			if (this.selectionShopArr.length > 10) {
				this.$message.warning('最多选择十条活动');
				return;
			}
			sessionStorage.setItem('selectionShopArr', JSON.stringify(this.selectionShopArr));
			let handLink = this.$router.resolve({
				path: '/channel/details',
				query: {
					desc: 'batch',
				},
			});
			window.open(handLink.href, '_blank');
		},

		//选中值
		checkeFun(e) {
			this.filterArr = [];
			this.filterArr = this.list.filter(item => item.other_status !== 2).filter(item => item.other_status !== 3);
			this.$refs.multiTable.$refs.baseTable.toggleSelection(this.filterArr, e);
		},
		//筛选
		ksOnSubmit(val) {
			this.ksParams = val;
			this.pageInfo.page_index = 1;
			this.getList('search');
		},
		//筛选
		dyOnSubmit(val) {
			Object.assign(this.dyParams, val);
			this.pageInfo.page_index = 1;
			this.getList('search');
		},
		getSyncTime() {
			this.$refs.updateTime.getSyncTime('', this.platformId);
		},
		async show() {
			const { platformId } = this;
			this.commanderList = await getCommanderList(true, platformId);
			if (!this.commanderList.length) {
				this.$message.error('暂无已授权团长，请联系管理员在“团队管理-团长授权”中进行团长授权');
				return;
			}
			this.updateList();
		},
		async updateList() {
			const { sync_type, authorityId: authority_id } = this;
			if (!authority_id) {
				this.$message.error('请选择团长');
				return;
			}
			const { code } = await activitySync({ type: sync_type, authority_id });
			if (code !== 0) return;
			this.$message({
				iconClass: 'el-icon-info primary mr-10',
				message: '活动正在同步...',
			});
		},
		//同步
		// 保持不变
		async synchroFun() {
			const params = { platform_id: this.platformId };
			const data = await checkAuthorize(params);
			if (!data.bind_status) {
				this.checkAuthAdd(this.platformId);
			} else {
				this.show();
			}
		},
		//全选
		checkeAll(val) {
			this.selectionShopArr = val ? this.list : [];
			this.changeData('isIndeterminate', false);
		},
		// 用于变更全选状态
		changeData(key, value) {
			this[key] = value;
		},
		// 得到选中的列表
		checkedItemFn(val) {
			this.selectionShopArr = val;
		},
	},
};
</script>
<style lang="less" scoped>
.activity-square {
	height: 100%;
	overflow: auto;
	.loading-text,
	.no-more {
		margin-top: 12px;
		height: 60px;
		color: @color-gy6;
	}
	/deep/ .el-loading-mask {
		background: @color-gy2;
	}
	.back-top {
		width: 40px;
		height: 40px;
		color: @color-primary;
	}
}
.form-item {
	display: flex;
	align-items: center;
	.form-label {
		font-weight: bold;
		margin-right: 12px;
		color: #666;
		font-size: 14px;
	}
}
.yx-background-white {
	position: absolute !important;
	right: 12px !important;
}
</style>
